'use strict';

$(function(){
    var message_popup = $('.message_popup');
    $('.ok', message_popup).on('click', function(){
        message_popup.removeClass('enabled');
    });
});